import {InvoiceTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function invoiceTypeNameFilter(type: InvoiceTypeEnum){
  switch (type) {
    case InvoiceTypeEnum.Individual: return i18n.t(LF.Individual) as string;
    case InvoiceTypeEnum.Business: return i18n.t(LF.Company) as string;
  }
}
